export const EDIT_SUCCESS = 'Пользователь обновлен';
export const EDIT_ERROR = 'Не удалось обновить пользователя';
